import jQuery from 'jquery/dist/jquery';

const $ = jQuery;
window.jQuery = $;
window.$ = $;
export { jQuery, $ };
